import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { Component, Injector } from '@angular/core';
import { Category } from '../models/category.model';
import { CategoryService } from '../services/category.service';
import { Validators } from '@angular/forms';
import { Subcategory } from '../models/subcategory.model';
import { SubcategoryService } from '../services/subcategory.service';

@Component({
    selector: 'ng-subcategory-form',
    templateUrl: 'subcategory-form.component.html'
})

export class SubcategoryFormComponent extends BaseFormComponent<Subcategory> {

    public categories:Category[];

    constructor(protected injector: Injector, protected categoryServ: CategoryService,protected subcategoryServ: SubcategoryService) {
        super(injector, 'category', '/admin/settings/subcategory', Subcategory.fromJsonToObject, subcategoryServ);
    }

    protected buildForm(): void {
        this.objectForm = this.formBuilder.group({
            name: this.formBuilder.control(null, [Validators.required]),
            producto_categorias_id: this.formBuilder.control(null, [Validators.required]),
            id: this.formBuilder.control(null),
        })
    }

    protected initChildProprieties(): void {
        this.categories=new Array<Category>();
     }
    protected initChildMethods(): void { 
        this.formSubscription.add(this.categoryServ.getAll().subscribe(categories=>this.categories=categories))
    }
}